/*****************************************************************************/
/*  File Name: freeTipOverview.js                                            */
/*  Purpose:   Displays the free tip impact summary                          */
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';
import styles from './styles/roi.module.scss';
import { useROIContext } from '../../context/roiContext';
import { convertToCurrency } from '../../functions/convertCurrency';

function FreeTipOverview({ t }) {
  const {
    totalFreeTipCount,
    freeTipPureProfit,
    patientsToBreakEvenWithFreeTips,
    patientsToBreakEvenWithoutFreeTips,
  } = useROIContext();

  const freeTipCount = totalFreeTipCount();

  if (!freeTipCount) {
    return null;
  }

  return (
    <div className={styles.freeTipOverview}>
      <div className={styles.freeTipOverviewTitle}>Free Tip Overview</div>
      <div className={styles.freeTipOverviewMetrics}>
        <div className={`${styles.freeTipOverviewMetric} ${styles.freeTipOverviewProfitMetric}`}>
          <div className={styles.freeTipOverviewLabel}>
            Pure gross profit on the first
            <br /> {freeTipCount} {freeTipCount === 1 ? 'patient' : 'patients'} (with free tips)
          </div>
          <div className={styles.freeTipOverviewValue}>${convertToCurrency(freeTipPureProfit())}</div>
        </div>
        <div className={styles.freeTipOverviewMetric}>
          <div className={styles.freeTipOverviewLabel}>
            Patients to
            <br /> breakeven
          </div>
          <div className={styles.freeTipOverviewValue}>{patientsToBreakEvenWithFreeTips()}</div>
          <div className={styles.freeTipOverviewSubLabel}>With free tips</div>
        </div>
        <div className={styles.freeTipOverviewVs}>VS</div>
        <div className={styles.freeTipOverviewMetric}>
          <div className={styles.freeTipOverviewLabel}>
            Patients to
            <br /> breakeven
          </div>
          <div className={styles.freeTipOverviewValue}>{patientsToBreakEvenWithoutFreeTips()}</div>
          <div className={styles.freeTipOverviewSubLabel}>No free tips</div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(FreeTipOverview);
